export default __webpack_public_path__ + "static/media/project-2.46e6d430.png";